import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

export async function sendMessage(message: string) {
  const { data } = await axios.post(`${API_HOST}/v1/employee-self-service/message`, {
    message,
  });
  return data;
}

const employeeSelfService = {
  sendMessage,
};

export default employeeSelfService;
